var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm._m(0),
    _vm.details.proofCertificateId
      ? _c(
          "div",
          { staticClass: "field" },
          [
            _c("div", { staticClass: "label text-caption" }, [
              _vm._v("Cancellation Certificate"),
            ]),
            _c("VatCertificate", {
              attrs: { "certificate-id": _vm.details.proofCertificateId },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "label text-caption" }, [
        _vm._v("Has Voec Details"),
      ]),
      _c("span", [_vm._v(_vm._s(_vm.details.haveOwnVoecId ? "Yes" : "No"))]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "field" }, [
      _c("div", { staticClass: "label text-caption" }, [_vm._v(" Vat id")]),
      _c("span", [_vm._v("No own VAT ID")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }